import { render, staticRenderFns } from "./CheckboxReadOnly.vue?vue&type=template&id=688affd1&"
import script from "./CheckboxReadOnly.vue?vue&type=script&lang=js&"
export * from "./CheckboxReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688affd1')) {
      api.createRecord('688affd1', component.options)
    } else {
      api.reload('688affd1', component.options)
    }
    module.hot.accept("./CheckboxReadOnly.vue?vue&type=template&id=688affd1&", function () {
      api.rerender('688affd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox/CheckboxReadOnly.vue"
export default component.exports